import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-file-download',
  templateUrl: './file-download.component.html',
})
export class FileDownloadComponent {
  @Input() file: string;

  get extension() {
    if (this.file) {
      const path = this.file.toLowerCase().split('?')[0];
      if (path.lastIndexOf('.') >= 0) {
        return path.substr(path.lastIndexOf('.') + 1);
      }
    }
    return null;
  }
}
